import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { PHOTO_EDIT_STATUS } from 'domains/seller-inventory-batch/constants'


const propTypes = {
  photo_edit_status: PropTypes.string
}

/**
 * To give nice look on Seller Inventory Batch `photo_edit_status`.
 * It maps `photo_edit_status` to certain style and pass to `StatusBadge`.
 * @param {string} photo_edit_status Seller Inbound Inventory Batch. available values
 * - `small_studio`
 * - `big_studio`
 */
const PhotoEditStatusBadge = ({ photo_edit_status }) => {

  const colorMap = {
    [PHOTO_EDIT_STATUS.PENDING]  : 'danger',
    [PHOTO_EDIT_STATUS.COMPLETE] : 'success'
  }

  const color = colorMap[photo_edit_status]

  return <StatusBadge color={ color } label={ photo_edit_status } />
}

PhotoEditStatusBadge.propTypes = propTypes

export default PhotoEditStatusBadge